
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.322 3.922a1.107 1.107 0 000 1.567l2.034 2.033 4.166-4.167L5.49 1.322a1.107 1.107 0 00-1.567 0l-2.6 2.6zM21 21v-4.167L8.71 4.544 4.545 8.711 16.834 21H21z","fill":"#324997"}})])
          )
        }
      }
    